/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react';

import {useIntl} from 'react-intl';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import { Modal, Tooltip } from "react-bootstrap";
import ReactLoading from 'react-loading';
import { useFormik } from 'formik';
import InputMask from "react-input-mask";

import {
  KTSVG,
  toAbsoluteUrl
} from '../../../_metronic/helpers';

import LoadingContent from '../../modules/loading/LoadingContent'
import RenderError from '../../utils/RenderError'

import {
  fetchCreditCards,
  fetchCreateCreditCard,
  fetchGetCep
} from '../../services/creditCard'

import creditCardType, {
  getTypeInfo,
  types as CardType,
} from "credit-card-type";

// import verifyPhoneAnimation from '../../../_metronic/assets/animations/verifyPhone.json';

const CreateCreditCard = ({isOpen, onClosed}) => {
  const { creditCards } = useSelector((state : any) => ({
    creditCards: state.creditCards,
  }), shallowEqual);

  const intl = useIntl();
  const location :any = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [cardType, setCardType] = useState<any>(null);
  const [paymentErrors, setPaymentErrors] = useState<any>(null);

  const close = () => {
    setOpen(false);

    onClosed && onClosed();

    setCardType(null);

    formik.resetForm();
  }

  useEffect(() => {
    if (open) {
    }
  }, [open]);

  useEffect(() => {
    if (isOpen) {
      setOpen(true);
    } else {
      close();
    }
  }, [isOpen]);

  const verifyCard = (value) => {
    if (value) {
      let types = creditCardType(value.replaceAll(' ', ''));
      if (types.length === 1) {
        let type = types[0].type;

        if (type == 'maestro') {
          type = 'mastercard';
        }
        if (type == 'american-express') {
          type = 'amex';
        }
        if (type == 'diners-club') {
          type = 'diners';
        }
        if (type == 'hiper') {
          type = 'hipercard';
        }

        setCardType(type);
      } else {
        setCardType(null);
      }
    }
  }

  const formik = useFormik<any>({
    initialValues: {
      card: '',
      holder_name: '',
      expired_at: '',
      cvv: '',
      label: '',
      country: '',
      state: '',
      city: '',
      zip_code: '',
      address: '',
      number: '',
      line_2: '',
      neighborhood: ''
    },
    onSubmit: (values) => {
      dispatch<any>(fetchCreateCreditCard(
        values.card.replace(/\s/g, ''),
        values.holder_name,
        values.expired_at.split('/')[0],
        values.expired_at.split('/')[1],
        values.cvv,
        values.document.match(/\d/g).join(""),
        values.label,
        values.country,
        values.state,
        values.city,
        values.zip_code.match(/\d/g).join(""),
        values.address,
        values.number,
        values.line_2,
        values.neighborhood
      )).then((response: any) => {
        dispatch<any>(fetchCreditCards());

        close();
      })
      .catch(value => {
        console.log(value)
        setPaymentErrors(value);
      });
    },
  });

  useEffect(() => {
    verifyCard(formik.values.card);
  }, [formik.values.card]);

  useEffect(() => {
    const cep = formik.values.zip_code;

    if (cep?.length > 0 && cep?.match(/\d/g).join("").length == 8) {
      fetchGetCep(cep.match(/\d/g).join("")).then((value : any) => {
        formik.setFieldValue("address", value.logradouro, false);
        formik.setFieldValue("neighborhood", value.bairro, false);
        formik.setFieldValue("city", value.localidade, false);
        formik.setFieldValue("state", value.uf, false);
      });
    }
  }, [formik.values.zip_code]);

  return (
    <>

      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open}
        onHide={() => close()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg" className="py-7 flex-root d-flex justify-content-center">
            <h2 className="fd-uppercase">Novo cartão de crédito</h2>
          </Modal.Title>

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form
            className="mx-auto mw-450px w-100 pt-0 pb-10"
            id="kt_modal_offer_a_deal_form"
            onSubmit={formik.handleSubmit}
          >
            <div className="current" data-kt-stepper-element="content">
              <div className="w-100">
                <div className='pb-10 pb-lg-15 text-center'>
                  <span className='fw-bold me-5 text-justify fs-3 text-gray-800'>
                    Faremos uma pequena cobrança com <br />devolução automática.
                  </span>

                  <div className='text-gray-400 fw-bold fs-6 mt-5'>
                    <img src={toAbsoluteUrl(`/media/custom/card_mastercard.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_visa.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_elo.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_diners.png`)} width="40" className="me-2" />
                  </div>
                  <div className='text-gray-400 fw-bold fs-6 mt-5'>
                    <img src={toAbsoluteUrl(`/media/custom/card_discover.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_amex.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_hipercard.png`)} width="40" className="me-2" />
                    <img src={toAbsoluteUrl(`/media/custom/card_jcb.png`)} width="40" className="me-2" />
                  </div>
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='fs-6 fw-bold form-label mb-2'>Número do cartão</label>

                  <div className='position-relative'>
                    <InputMask
                      placeholder='4444 4444 4444 4444'
                      mask="9999 9999 9999 9999"
                      maskPlaceholder=" "
                      className='form-control form-control-solid-bg'
                      autoComplete="cc-number"
                      {...formik.getFieldProps('card')}
                    />
                    {/*<div className='text-danger mt-2'>
                      Número de cartão inválido
                    </div>*/}

                    {paymentErrors && <RenderError error={paymentErrors['request.card.number']} />}

                    <div className='position-absolute translate-middle-y top-50 end-0 me-5'>
                      <img src={toAbsoluteUrl(`/media/custom/card_${cardType}.png`)} alt='' className='h-25px' />
                    </div>
                  </div>
                </div>

                <div className='row mb-5'>
                  <div className='col-md-7 fv-row'>
                    <label className='fs-6 fw-bold form-label mb-2'>Data de validade</label>

                    <InputMask
                      placeholder='10/2030'
                      mask="99/9999"
                      maskPlaceholder=""
                      maskChar=""
                      className='form-control form-control-solid-bg'
                      autoComplete="cc-exp-date"
                      {...formik.getFieldProps('expired_at')}
                    />
                    {paymentErrors && <RenderError error={paymentErrors['request.card.exp_month']} />}

                    {/*<div className='row fv-row'>
                      <div className='col-6'>
                        <select name='cardExpiryMonth' className='form-select form-select-solid-bg'>
                          <option></option>
                          <option value='1'>1</option>
                          <option value='2'>2</option>
                          <option value='3'>3</option>
                          <option value='4'>4</option>
                          <option value='5'>5</option>
                          <option value='6'>6</option>
                          <option value='7'>7</option>
                          <option value='8'>8</option>
                          <option value='9'>9</option>
                          <option value='10'>10</option>
                          <option value='11'>11</option>
                          <option value='12'>12</option>
                        </select>
                        <div className='text-danger mt-2'>
                        </div>
                      </div>

                      <div className='col-6'>
                        <select name='cardExpiryYear' className='form-select form-select-solid-bg'>
                          <option></option>
                          <option value='2023'>2023</option>
                          <option value='2024'>2024</option>
                          <option value='2025'>2025</option>
                          <option value='2026'>2026</option>
                          <option value='2027'>2027</option>
                          <option value='2028'>2028</option>
                          <option value='2029'>2029</option>
                          <option value='2030'>2030</option>
                          <option value='2031'>2031</option>
                        </select>
                        <div className='text-danger mt-2'>
                        </div>
                      </div>
                    </div>*/}
                  </div>

                  <div className='col-md-5 fv-row'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className=''>CVV</span>
                    </label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid-bg'
                        minLength={3}
                        maxLength={4}
                        placeholder='CVV'
                        autoComplete="cc-csc"
                        {...formik.getFieldProps('cvv')}
                      />

                      <div className='position-absolute translate-middle-y top-50 end-0 me-3'>
                        <KTSVG path='/media/icons/duotune/finance/fin002.svg' className='svg-icon-2hx' />
                      </div>
                    </div>

                    {paymentErrors && <RenderError error={paymentErrors['request.card.cvv']} />}
                  </div>
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className=''>Apelido do cartão</span>
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder='Opcional'
                    {...formik.getFieldProps('label')}
                  />
                  <div className='text-danger mt-2'>
                  </div>
                </div>

                <div className="separator mx-0 mb-5"></div>

                <div className='d-flex flex-column mb-5 fv-row text-center'>
                  <span className='fw-bold me-5 text-justify fs-4 text-gray-800'>
                    Informações do titular
                  </span>
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className='required'>Nome do titular</span>
                    {/*<i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title="Specify a card holder's name"
                    ></i>*/}
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder=''
                    autoComplete="cc-name"
                    {...formik.getFieldProps('holder_name')}
                  />

                  {paymentErrors && <RenderError error={paymentErrors['request.card.holder_name']} />}
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className='required'>CPF / CNPJ do titular</span>
                    {/*<i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title="Specify a card holder's name"
                    ></i>*/}
                  </label>

                  {/*<input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder=''
                    name='nameOnCard'
                  />*/}
                  <InputMask
                    placeholder='444.444.444-44'
                    mask={formik.values.document?.length < 15 ? "999.999.999-99" : "99.999.999/9999-99"}
                    maskPlaceholder=""
                    maskChar=""
                    className='form-control form-control-solid-bg'
                    {...formik.getFieldProps('document')}
                  />

                  <div className='text-danger mt-2'>
                  </div>
                </div>

                <div className="separator mx-0 mb-5"></div>

                <div className='d-flex flex-column mb-5 fv-row text-center'>
                  <span className='fw-bold me-5 text-justify fs-4 text-gray-800'>
                    Endereço de cobrança
                  </span>
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className=''>CEP</span>
                    {/*<i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title="Specify a card holder's name"
                    ></i>*/}
                  </label>

                  {/*<input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder=''
                    name='nameOnCard'
                  />*/}

                  <InputMask
                    placeholder='Digite o cep'
                    mask={"99999-999"}
                    maskPlaceholder=""
                    maskChar=""
                    className='form-control form-control-solid-bg'
                    {...formik.getFieldProps('zip_code')}
                  />

                  <div className='text-danger mt-2'>
                  </div>
                </div>

                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className=''>Endereço</span>
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder='Endereço'
                    {...formik.getFieldProps('address')}
                  />
                  <div className='text-danger mt-2'>
                  </div>
                </div>



                <div className='row mb-5 fv-row'>
                  <div className='col-6'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className=''>Número</span>
                    </label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid-bg'
                        {...formik.getFieldProps('number')}
                      />
                      <div className='text-danger mt-2'>
                      </div>
                    </div>
                  </div>

                  <div className='col-6'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className=''>Bairro</span>
                    </label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid-bg'
                        {...formik.getFieldProps('neighborhood')}
                      />
                      <div className='text-danger mt-2'>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-5 fv-row'>
                  <div className='col-md-6 fv-row'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className=''>Cidade</span>
                    </label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid-bg'
                        {...formik.getFieldProps('city')}
                      />
                      <div className='text-danger mt-2'>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 fv-row'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className=''>Estado</span>
                    </label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid-bg'
                        {...formik.getFieldProps('state')}
                      />
                      <div className='text-danger mt-2'>
                      </div>
                    </div>
                  </div>
                </div>

                {paymentErrors && paymentErrors != '' && <div className='row mb-5 fv-row'>
                  <div className='col-md-12 fv-row'>
                    <div className="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10">
                      <div className="d-flex flex-column text-primary pe-0 pe-sm-10">
                        <h5 className="mb-1">Erro ao entrar</h5>
                        <span>{paymentErrors}</span>
                      </div>
                      <button
                        type="button"
                        className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                        onClick={() => setPaymentErrors('')}
                      >
                        <span className="svg-icon svg-icon-1 svg-icon-primary">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>}

                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3 btn-active-light-danger'
                      onClick={() => close()}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr063.svg'
                        className='svg-icon-3 me-1'
                      />{' '}
                      Voltar
                    </button>
                  </div>
                  <div>
                    <button
                      type='submit'
                      className='btn btn-lg btn-primary'
                      disabled={creditCards.actionsLoading}
                    >
                      {!creditCards.actionsLoading && <>
                        Cadastrar cartão{' '}
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr064.svg'
                          className='svg-icon-3 ms-2 me-0'
                        />
                      </>}
                      {creditCards.actionsLoading && <span className="indicator-label">
                        Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>}
                    </button>

                    {/*<button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={nextStep}
                    >
                      Next Step{' '}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-1 me-0'
                      />
                    </button>*/}
                  </div>
                </div>
                {/*<div className='d-flex flex-stack'>
                  <div className='me-5'>
                    <label className='fs-6 fw-bold form-label'>Save Card for further billing?</label>
                    <div className='fs-7 fw-bold text-gray-400'>
                      If you need more info, please check budget planning
                    </div>
                  </div>

                  <label className='form-check form-switch form-check-custom form-check-solid'>
                    <input className='form-check-input' type='checkbox' value='1' checked={true} />
                    <span className='form-check-label fw-bold text-gray-400'>Save Card</span>
                  </label>
                </div>*/}

              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CreateCreditCard;
